import { render, staticRenderFns } from "./cunsubarea.vue?vue&type=template&id=bd4f2564"
import script from "./cunsubarea.vue?vue&type=script&lang=js"
export * from "./cunsubarea.vue?vue&type=script&lang=js"
import style0 from "./cunsubarea.vue?vue&type=style&index=0&id=bd4f2564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports